export default __webpack_public_path__ + "static/media/Mickey-Mouse-Skeleton-Key-Earrings.efb85794.jpg";